export enum FormMode {
    Add = 'add',
    Edit = 'edit'
}